@if (cardData) {
  <div class="card-container">
    <div class="card-header">
      {{ 'global.regionChartHeader' | translate }}
    </div>
    @if (cardData.chartData.length >= 1) {
      @if (doughnutChartData) {
        <div class="chart-container">
          <canvas
            baseChart
            [data]="doughnutChartData"
            [options]="doughnutChartOptions"
            [type]="'doughnut'"
            [legend]="false"
            >
          </canvas>
        </div>
      }
    } @else {
      <div class="no-instruments">
        {{ 'global.error.noInstrumentsSelected' | translate }}
      </div>
    }
    <div class="row instruments-container">
      <div class="col-6">
        <div class="table-label table-label--instrument">
          {{ 'global.region' | translate }}
        </div>
      </div>
      <div class="col-6">
        <div class="table-label table-label--value">
          {{ 'global.share' | translate }}
        </div>
      </div>
    </div>
    <hr class="divider">
    @for (dropdown of dropdownData; track dropdown; let i = $index) {
      <div class="dropdown-container">
        <libero-instrument-chart-dropdown
          [dropdownInput]="dropdown"
          [translateNames]="false"
          [customColor]="datasetsColors[i]"
          [region]="true"
        ></libero-instrument-chart-dropdown>
        <hr class="divider">
      </div>
    }
  </div>
}
